module.exports = __webpack_public_path__ + "static/media/weather1.8605aaa4.jpg";